/*! OtakuIsland theme.js — vanilla JS, no build step */
(function () {
  'use strict';

  var otk = window.otk || {};
  var routes = otk.routes || {};
  var strings = otk.strings || {};
  var settingsCfg = otk.settings || {};

  /* ------------------------------------------------------------------ */
  /* Utilities                                                          */
  /* ------------------------------------------------------------------ */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, evt, sel, fn) {
    if (typeof sel === 'function') { fn = sel; sel = null; }
    el.addEventListener(evt, function (e) {
      if (!sel) { fn(e, el); return; }
      var target = e.target.closest(sel);
      if (target && el.contains(target)) fn(e, target);
    });
  }
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    // Indian-style grouping (last 3 digits, then groups of 2) if currency looks like INR
    if ((otk.money && otk.money.currency) === 'INR') {
      whole = indianGroup(parts[0]);
    }
    var currency = (otk.money && otk.money.currency) || 'INR';
    var symbol = currency === 'INR' ? '\u20B9' : (currency + ' ');
    return symbol + whole;
  }
  function indianGroup(numStr) {
    var neg = numStr.charAt(0) === '-';
    if (neg) numStr = numStr.slice(1);
    var last3 = numStr.slice(-3);
    var rest = numStr.slice(0, -3);
    if (rest !== '') last3 = ',' + last3;
    rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
    return (neg ? '-' : '') + rest + last3;
  }

  function trapFocus(container) {
    var focusable = qsa('a[href], button:not([disabled]), input, textarea, select, [tabindex]:not([tabindex="-1"])', container);
    if (!focusable.length) return function () {};
    var first = focusable[0], last = focusable[focusable.length - 1];
    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handler);
    return function () { container.removeEventListener('keydown', handler); };
  }

  var lastFocused = null;
  function lockScroll(lock) {
    document.documentElement.style.overflow = lock ? 'hidden' : '';
  }

  /* ------------------------------------------------------------------ */
  /* Toast                                                              */
  /* ------------------------------------------------------------------ */
  var toastTimer;
  function toast(msg, isError) {
    var el = qs('#Toast'), msgEl = qs('#ToastMsg');
    if (!el || !msgEl) return;
    msgEl.textContent = msg;
    el.hidden = false;
    el.classList.toggle('is-error', !!isError);
    requestAnimationFrame(function () { el.classList.add('is-show'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-show');
      setTimeout(function () { el.hidden = true; }, 250);
    }, 2600);
  }
  otk.toast = toast;

  /* ------------------------------------------------------------------ */
  /* Theme (dark / light) toggle                                        */
  /* ------------------------------------------------------------------ */
  function initThemeToggle() {
    var btns = qsa('[data-theme-toggle]');
    if (!btns.length) return;
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var html = document.documentElement;
        var current = html.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
        var next = current === 'light' ? 'dark' : 'light';
        html.setAttribute('data-theme', next);
        try { localStorage.setItem('otk-theme', next); } catch (e) {}
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Announcement bar dismiss                                           */
  /* ------------------------------------------------------------------ */
  function initAnnouncement() {
    var bar = qs('[data-announce]');
    if (!bar) return;
    try {
      if (sessionStorage.getItem('otk-announce-closed') === '1') { bar.hidden = true; return; }
    } catch (e) {}
    var closeBtn = qs('[data-announce-close]', bar);
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.hidden = true;
        try { sessionStorage.setItem('otk-announce-closed', '1'); } catch (e) {}
      });
    }
  }

  /* ------------------------------------------------------------------ */
  /* Mobile menu                                                        */
  /* ------------------------------------------------------------------ */
  function initMobileMenu() {
    var menu = qs('#MobileMenu'), overlay = qs('[data-menu-overlay]');
    var openBtns = qsa('[data-menu-open]'), closeBtns = qsa('[data-menu-close]');
    if (!menu || !overlay) return;
    var releaseFocus;

    function open() {
      lastFocused = document.activeElement;
      menu.classList.add('is-open');
      overlay.classList.add('is-open');
      overlay.hidden = false;
      menu.setAttribute('aria-hidden', 'false');
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      lockScroll(true);
      releaseFocus = trapFocus(menu);
      var closeBtn = qs('[data-menu-close]', menu);
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      menu.classList.remove('is-open');
      overlay.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      lockScroll(false);
      if (releaseFocus) releaseFocus();
      setTimeout(function () { overlay.hidden = true; }, 300);
      if (lastFocused) lastFocused.focus();
    }
    openBtns.forEach(function (b) { b.addEventListener('click', open); });
    closeBtns.forEach(function (b) { b.addEventListener('click', close); });
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) close();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Predictive search                                                  */
  /* ------------------------------------------------------------------ */
  function initSearch() {
    var forms = qsa('[data-search-form]');
    if (!forms.length) return;

    forms.forEach(function (form) {
      var input = qs('[data-search-input]', form);
      var panel = qs('[data-search-panel]', form);
      if (!input || !panel) return;
      var currentFocus = -1;

      function closePanel() { panel.hidden = true; panel.innerHTML = ''; currentFocus = -1; }

      if (!settingsCfg.predictive) {
        return; // Basic search submit only.
      }

      var run = debounce(function () {
        var term = input.value.trim();
        if (term.length < 2) { closePanel(); return; }
        var url = routes.predictiveSearch + '?q=' + encodeURIComponent(term) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search';
        fetch(url, { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            renderResults(data, term);
          })
          .catch(function () { closePanel(); });
      }, 220);

      function renderResults(data, term) {
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          panel.innerHTML = '<p class="sp-empty">' + (strings.noResults || 'No results for "' + escapeHtml(term) + '"') + '</p>';
          panel.hidden = false;
          return;
        }
        var html = '<p class="sp-head">Products</p>';
        products.forEach(function (p) {
          html += '<a class="sp-item" href="' + p.url + '">' +
            (p.image ? '<img src="' + p.image + '&width=96" alt="" loading="lazy">' : '') +
            '<span class="sp-item__t">' + escapeHtml(p.title) + '</span>' +
            '<span class="sp-item__p">' + p.price + '</span>' +
            '</a>';
        });
        html += '<a class="sp-all" href="' + routes.search + '?q=' + encodeURIComponent(term) + '&type=product">View all results</a>';
        panel.innerHTML = html;
        panel.hidden = false;
        currentFocus = -1;
      }

      input.addEventListener('input', run);
      input.addEventListener('focus', function () { if (input.value.trim().length >= 2) run(); });
      input.addEventListener('keydown', function (e) {
        var items = qsa('.sp-item', panel);
        if (!items.length) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); currentFocus = Math.min(currentFocus + 1, items.length - 1); items[currentFocus].focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); currentFocus = Math.max(currentFocus - 1, 0); items[currentFocus].focus(); }
        else if (e.key === 'Escape') { closePanel(); input.blur(); }
      });
      document.addEventListener('click', function (e) {
        if (!form.contains(e.target)) closePanel();
      });
    });

    // Ctrl/Cmd+K focuses the first search input.
    document.addEventListener('keydown', function (e) {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
        var input = qs('[data-search-input]');
        if (input) { e.preventDefault(); input.focus(); }
      }
    });
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }

  /* ------------------------------------------------------------------ */
  /* Cart (AJAX) — drawer + page                                        */
  /* ------------------------------------------------------------------ */
  var Cart = (function () {
    function fetchJSON(url, opts) {
      opts = opts || {};
      opts.headers = Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json' }, opts.headers || {});
      return fetch(url, opts).then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw d; });
        return r.json();
      });
    }

    function refreshFragments(cart) {
      updateCounts(cart);
      updateShipBar(cart);
      reloadCartMarkup();
      return cart;
    }

    function updateCounts(cart) {
      qsa('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      qsa('[data-cart-count-label]').forEach(function (el) {
        el.textContent = '(' + cart.item_count + ')';
      });
    }

    function updateShipBar(cart) {
      var bar = qs('[data-ship-bar]');
      if (!bar) return;
      var threshold = settingsCfg.freeShipping || 0;
      var msg = qs('[data-ship-msg]', bar), fill = qs('[data-ship-fill]', bar);
      if (threshold <= 0) { bar.hidden = true; return; }
      var total = cart.total_price;
      if (total >= threshold) {
        msg.innerHTML = '\u2713 ' + (strings.freeShippingUnlocked || "You've unlocked FREE shipping!");
        msg.classList.add('is-done');
        fill.style.width = '100%';
        fill.classList.add('is-done');
      } else {
        var remaining = threshold - total;
        var tmpl = strings.freeShippingAway || 'Add {{ amount }} more for FREE shipping';
        msg.innerHTML = tmpl.replace('{{ amount }}', '<strong>' + formatMoney(remaining) + '</strong>');
        msg.classList.remove('is-done');
        fill.style.width = Math.min(100, (total / threshold) * 100) + '%';
        fill.classList.remove('is-done');
      }
    }

    function reloadCartMarkup() {
      // Re-render items + footer fragments via Section Rendering API when available;
      // fall back to a lightweight manual re-render using /cart.js.
      var itemsWrap = qs('[data-cart-items]');
      var footWrap = qs('[data-cart-footer]');
      if (!itemsWrap && !footWrap) return;
      fetchJSON(routes.cartJson).then(function (cart) {
        renderItems(cart, itemsWrap);
        renderFooter(cart, footWrap);
        updateCounts(cart);
        updateShipBar(cart);
      });
    }

    function renderItems(cart, wrap) {
      if (!wrap) return;
      if (cart.item_count === 0) {
        wrap.innerHTML =
          '<div class="cart-empty">' +
          '<div class="cart-empty__icon"></div>' +
          '<p class="cart-empty__title">' + strings.cartEmpty || 'Your cart is empty' + '</p>' +
          '<a href="' + routes.root + 'collections/all" class="btn btn--primary" data-drawer-close>Start shopping</a>' +
          '</div>';
        return;
      }
      var html = '<ul class="cart-list">';
      cart.items.forEach(function (item, i) {
        var line = i + 1;
        html += '<li class="cart-item" data-line="' + line + '" data-key="' + item.key + '">' +
          '<a class="cart-item__img" href="' + item.url + '">' +
          (item.image ? '<img src="' + item.image.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '$1$2') + '" width="80" height="80" alt="">' : '') +
          '</a>' +
          '<div class="cart-item__body">' +
          '<p class="cart-item__vendor">' + escapeHtml(item.product_type || item.vendor || '') + '</p>' +
          '<a class="cart-item__title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' +
          (item.variant_title ? '<p class="cart-item__variant">' + escapeHtml(item.variant_title) + '</p>' : '') +
          '<div class="cart-item__row">' +
          '<div class="qty qty--sm" data-qty>' +
          '<button type="button" class="qty__btn" data-qty-minus data-line="' + line + '" aria-label="Decrease quantity">\u2212</button>' +
          '<input class="qty__input" type="number" min="0" value="' + item.quantity + '" data-line="' + line + '">' +
          '<button type="button" class="qty__btn" data-qty-plus data-line="' + line + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<div class="cart-item__price">' +
          (item.original_line_price > item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '') +
          '<strong>' + formatMoney(item.final_line_price) + '</strong>' +
          '</div></div></div>' +
          '<button type="button" class="cart-item__remove" data-remove-line="' + line + '" aria-label="Remove">\u2715</button>' +
          '</li>';
      });
      html += '</ul>';
      wrap.innerHTML = html;
    }

    function renderFooter(cart, wrap) {
      if (!wrap) return;
      if (cart.item_count === 0) { wrap.innerHTML = ''; return; }
      wrap.innerHTML =
        '<div class="cart-total"><span>Subtotal</span><strong data-cart-subtotal>' + formatMoney(cart.total_price) + '</strong></div>' +
        '<p class="cart-tax">Taxes included. Shipping calculated at checkout.</p>' +
        '<form action="' + routes.cart + '" method="post"><button type="submit" name="checkout" class="btn btn--primary btn--block">Checkout</button></form>' +
        '<a href="' + routes.cart + '" class="btn btn--ghost btn--block">View cart</a>';
    }

    function add(variantId, quantity, cb) {
      fetchJSON(routes.cartAdd, {
        method: 'POST',
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      }).then(function (item) {
        return fetchJSON(routes.cartJson).then(function (cart) {
          refreshFragments(cart);
          if (cb) cb(null, item, cart);
        });
      }).catch(function (err) {
        if (cb) cb(err);
      });
    }

    function changeLine(line, quantity, cb) {
      fetchJSON(routes.cartChange, {
        method: 'POST',
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (cart) {
        refreshFragments(cart);
        if (cb) cb(null, cart);
      }).catch(function (err) { if (cb) cb(err); });
    }

    function setNote(note) {
      return fetchJSON(routes.cartUpdate, { method: 'POST', body: JSON.stringify({ note: note }) });
    }

    return { add: add, changeLine: changeLine, setNote: setNote, refreshFragments: refreshFragments, formatMoney: formatMoney };
  })();
  otk.cart = Cart;

  function initCartDrawer() {
    var drawer = qs('#CartDrawer'), overlay = qs('[data-drawer-overlay]');
    var openBtns = qsa('[data-cart-open]');
    if (!drawer) return; // drawer disabled; cart page mode only.
    var releaseFocus;
    var isDrawerMode = settingsCfg.cartType === 'drawer';

    function open() {
      if (!isDrawerMode) return; // let default navigation to /cart happen
      lastFocused = document.activeElement;
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      overlay.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      releaseFocus = trapFocus(drawer);
    }
    function close() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      if (releaseFocus) releaseFocus();
      setTimeout(function () { if (overlay) overlay.hidden = true; }, 300);
    }

    openBtns.forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (isDrawerMode) { e.preventDefault(); open(); }
      });
    });
    qsa('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // Quantity / remove delegation (works for drawer + page via re-render).
    on(document, 'click', '[data-qty-plus]', function (e, btn) {
      var line = btn.getAttribute('data-line');
      handleQtyDelegated(btn, line, 1);
    });
    on(document, 'click', '[data-qty-minus]', function (e, btn) {
      var line = btn.getAttribute('data-line');
      handleQtyDelegated(btn, line, -1);
    });
    on(document, 'change', '[data-qty-input]', function (e, input) {
      var line = input.getAttribute('data-line');
      if (line) applyQty(line, parseInt(input.value, 10) || 0);
    });
    on(document, 'click', '[data-remove-line]', function (e, btn) {
      var line = btn.getAttribute('data-remove-line');
      var item = btn.closest('.cart-item');
      if (item) item.classList.add('is-updating');
      Cart.changeLine(line, 0, function (err) {
        if (err) toast(strings.error || 'Something went wrong', true);
      });
    });

    function handleQtyDelegated(btn, line, delta) {
      var wrap = btn.closest('.qty');
      var input = wrap ? qs('.qty__input', wrap) : null;
      var current = input ? parseInt(input.value, 10) || 0 : 0;
      var next = Math.max(0, current + delta);
      if (input) input.value = next;
      applyQty(line, next);
    }
    function applyQty(line, qty) {
      var item = qs('.cart-item[data-line="' + line + '"]');
      if (item) item.classList.add('is-updating');
      Cart.changeLine(line, qty, function (err) {
        if (err) toast(strings.error || 'Something went wrong', true);
      });
    }

    // Order note
    on(document, 'change', '[data-cart-note]', function (e, ta) {
      Cart.setNote(ta.value);
    });
  }

  function initQuickAdd() {
    on(document, 'click', '[data-quick-add]', function (e, btn) {
      e.preventDefault();
      if (btn.classList.contains('is-loading')) return;
      var variantId = btn.getAttribute('data-variant-id');
      var label = qs('span', btn);
      var originalText = label ? label.textContent : '';
      btn.classList.add('is-loading');
      if (label) label.textContent = strings.adding || 'Adding…';
      Cart.add(variantId, 1, function (err) {
        btn.classList.remove('is-loading');
        if (err) {
          if (label) label.textContent = originalText;
          toast((err && err.description) || strings.error || 'Something went wrong', true);
          return;
        }
        btn.classList.add('is-done');
        if (label) label.textContent = strings.addedToCart || 'Added to cart';
        toast(strings.addedToCart || 'Added to cart');
        setTimeout(function () {
          btn.classList.remove('is-done');
          if (label) label.textContent = originalText;
        }, 1600);
        openDrawerIfEnabled();
      });
    });
  }

  function openDrawerIfEnabled() {
    if (settingsCfg.cartType !== 'drawer') return;
    var openBtn = qs('[data-cart-open]');
    if (openBtn) openBtn.click();
  }

  /* ------------------------------------------------------------------ */
  /* Wishlist (localStorage-backed)                                     */
  /* ------------------------------------------------------------------ */
  var Wishlist = (function () {
    var KEY = 'otk-wishlist';
    function get() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
    }
    function save(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
      updateCount();
    }
    function has(handle) { return get().indexOf(handle) > -1; }
    function toggle(handle) {
      var list = get();
      var idx = list.indexOf(handle);
      var added;
      if (idx > -1) { list.splice(idx, 1); added = false; }
      else { list.push(handle); added = true; }
      save(list);
      return added;
    }
    function updateCount() {
      var count = get().length;
      qsa('[data-wishlist-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    }
    return { get: get, has: has, toggle: toggle, updateCount: updateCount };
  })();
  otk.wishlist = Wishlist;

  function initWishlist() {
    Wishlist.updateCount();
    qsa('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      btn.setAttribute('aria-pressed', Wishlist.has(handle) ? 'true' : 'false');
    });
    on(document, 'click', '[data-wishlist-toggle]', function (e, btn) {
      e.preventDefault();
      var handle = btn.getAttribute('data-handle');
      var added = Wishlist.toggle(handle);
      btn.setAttribute('aria-pressed', added ? 'true' : 'false');
      toast(added ? (strings.wishlistAdded || 'Added to wishlist') : (strings.wishlistRemoved || 'Removed from wishlist'));
    });
  }

  /* ------------------------------------------------------------------ */
  /* Share button                                                       */
  /* ------------------------------------------------------------------ */
  function initShare() {
    on(document, 'click', '[data-share]', function (e, btn) {
      var title = btn.getAttribute('data-share-title');
      var url = btn.getAttribute('data-share-url');
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          toast(strings.linkCopied || 'Link copied to clipboard');
        });
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* Hero slider                                                        */
  /* ------------------------------------------------------------------ */
  function initHero() {
    qsa('[data-hero]').forEach(function (hero) {
      var slides = qsa('[data-hero-slide]', hero);
      var dots = qsa('[data-hero-dot]', hero);
      if (slides.length < 2) return;
      var index = 0;
      var interval = parseInt(hero.getAttribute('data-interval'), 10) || 6000;
      var autoplay = hero.getAttribute('data-autoplay') === 'true';
      var timer;

      function show(i) {
        slides[index].classList.remove('is-active');
        slides[index].setAttribute('aria-hidden', 'true');
        if (dots[index]) dots[index].classList.remove('is-active');
        index = (i + slides.length) % slides.length;
        slides[index].classList.add('is-active');
        slides[index].removeAttribute('aria-hidden');
        if (dots[index]) dots[index].classList.add('is-active');
      }
      function next() { show(index + 1); }
      function prev() { show(index - 1); }
      function play() {
        if (!autoplay) return;
        stop();
        timer = setInterval(next, interval);
      }
      function stop() { clearInterval(timer); }

      var prevBtn = qs('[data-hero-prev]', hero), nextBtn = qs('[data-hero-next]', hero);
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); play(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); play(); });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { show(i); play(); });
      });
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', play);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', play);

      // Basic swipe support
      var startX = null;
      var viewport = qs('[data-hero-viewport]', hero);
      if (viewport) {
        viewport.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
        viewport.addEventListener('touchend', function (e) {
          if (startX === null) return;
          var dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) { dx > 0 ? prev() : next(); play(); }
          startX = null;
        }, { passive: true });
      }

      play();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Franchise carousel arrows                                          */
  /* ------------------------------------------------------------------ */
  function initFranchiseScroll() {
    qsa('[data-fr-scroll]').forEach(function (scroller) {
      var wrap = scroller.closest('.franchise__wrap');
      if (!wrap) return;
      var prev = qs('[data-fr-prev]', wrap), next = qs('[data-fr-next]', wrap);
      function amount() { return scroller.clientWidth * 0.8; }
      function update() {
        if (prev) prev.disabled = scroller.scrollLeft <= 2;
        if (next) next.disabled = scroller.scrollLeft >= scroller.scrollWidth - scroller.clientWidth - 2;
      }
      if (prev) prev.addEventListener('click', function () { scroller.scrollBy({ left: -amount(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { scroller.scrollBy({ left: amount(), behavior: 'smooth' }); });
      scroller.addEventListener('scroll', debounce(update, 100));
      update();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Accordions (FAQ + product tabs)                                    */
  /* ------------------------------------------------------------------ */
  function initAccordions() {
    on(document, 'click', '[data-acc-btn]', function (e, btn) {
      var acc = btn.closest('[data-acc]');
      var panel = acc.querySelector('.acc__panel');
      var isOpen = acc.classList.contains('is-open');
      var group = acc.closest('[data-accordion]');

      if (group && group.hasAttribute('data-single-open')) {
        qsa('[data-acc].is-open', group).forEach(function (other) {
          if (other !== acc) closeAcc(other);
        });
      }
      isOpen ? closeAcc(acc) : openAcc(acc);
    });

    function openAcc(acc) {
      var btn = qs('[data-acc-btn]', acc);
      var panel = qs('.acc__panel', acc);
      acc.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      panel.style.height = 'auto';
      var h = panel.scrollHeight;
      panel.style.height = '0px';
      requestAnimationFrame(function () {
        panel.style.transition = 'height .25s ease';
        panel.style.height = h + 'px';
      });
      panel.addEventListener('transitionend', function te() {
        panel.style.height = 'auto';
        panel.removeEventListener('transitionend', te);
      });
    }
    function closeAcc(acc) {
      var btn = qs('[data-acc-btn]', acc);
      var panel = qs('.acc__panel', acc);
      var h = panel.scrollHeight;
      panel.style.height = h + 'px';
      requestAnimationFrame(function () {
        panel.style.transition = 'height .25s ease';
        panel.style.height = '0px';
      });
      acc.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      panel.addEventListener('transitionend', function te() {
        panel.hidden = true;
        panel.removeEventListener('transitionend', te);
      });
    }
  }

  /* ------------------------------------------------------------------ */
  /* Product page: gallery, zoom, lightbox, variants, qty, pincode       */
  /* ------------------------------------------------------------------ */
  function initProductPage() {
    var section = qs('[data-product-section]');
    if (!section) return;

    var maxQty = parseInt(section.getAttribute('data-max-qty'), 10) || 10;
    var productDataEl = qs('[data-product-json]', section);
    var product = null;
    try { product = productDataEl ? JSON.parse(productDataEl.textContent) : null; } catch (e) {}

    initGallery(section);
    initVariantPicker(section, product);
    initQtyStepper(section, maxQty);
    initPincode(section);
    initStickyAtc(section);
    initFormSubmit(section);
    initBuyNow(section);
  }

  function initGallery(section) {
    var stage = qs('[data-gallery-stage]', section);
    var slides = qsa('[data-gallery-slide]', section);
    var thumbs = qsa('[data-gallery-thumb], .gallery__thumb', section);
    var counter = qs('[data-gallery-counter]', section);
    if (!stage || slides.length === 0) return;
    var index = 0;

    function show(i) {
      slides[index].classList.remove('is-active');
      if (thumbs[index]) thumbs[index].classList.remove('is-active');
      index = (i + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      if (thumbs[index]) thumbs[index].classList.add('is-active');
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
    }
    qsa('[data-gallery-prev]', section).forEach(function (b) { b.addEventListener('click', function () { show(index - 1); }); });
    qsa('[data-gallery-next]', section).forEach(function (b) { b.addEventListener('click', function () { show(index + 1); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });

    // Swipe
    var startX = null;
    stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(dx > 0 ? index - 1 : index + 1);
      startX = null;
    }, { passive: true });

    // Desktop hover zoom
    var mq = window.matchMedia('(hover: hover) and (pointer: fine)');
    function onMove(e) {
      var img = qs('.gallery__slide.is-active .gallery__img', section);
      if (!img) return;
      var rect = stage.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      stage.style.setProperty('--zx', x + '%');
      stage.style.setProperty('--zy', y + '%');
    }
    if (mq.matches) {
      stage.addEventListener('mouseenter', function () { stage.classList.add('is-zoomed'); });
      stage.addEventListener('mousemove', onMove);
      stage.addEventListener('mouseleave', function () { stage.classList.remove('is-zoomed'); });
    }

    // Click to open lightbox
    stage.addEventListener('click', function (e) {
      if (e.target.closest('[data-gallery-prev],[data-gallery-next]')) return;
      openLightbox(section, index);
    });

    section.__gallery = { show: show, get index() { return index; } };
  }

  function openLightbox(section, startIndex) {
    var lb = qs('[data-lightbox]', section);
    if (!lb) return;
    var slides = qsa('[data-gallery-slide]', section);
    var img = qs('[data-lightbox-img]', lb);
    var index = startIndex;

    function render() {
      var activeImg = qs('.gallery__img, .gallery__video', slides[index]);
      if (activeImg && activeImg.tagName === 'IMG') {
        img.src = activeImg.getAttribute('data-zoom-src') || activeImg.src;
        img.hidden = false;
      } else {
        img.hidden = true;
      }
    }
    render();
    lb.hidden = false;
    lockScroll(true);
    var release = trapFocus(lb);

    function close() {
      lb.hidden = true;
      lockScroll(false);
      release();
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') { index = (index + 1) % slides.length; render(); }
      if (e.key === 'ArrowLeft') { index = (index - 1 + slides.length) % slides.length; render(); }
    }
    document.addEventListener('keydown', onKey);
    qs('[data-lightbox-close]', lb).onclick = close;
    qs('[data-lightbox-next]', lb).onclick = function () { index = (index + 1) % slides.length; render(); };
    qs('[data-lightbox-prev]', lb).onclick = function () { index = (index - 1 + slides.length) % slides.length; render(); };
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); }, { once: true });
  }

  function initVariantPicker(section, product) {
    if (!product) return;
    var form = qs('[data-product-form]', section) || qs('.pform', section);
    var inputs = qsa('[data-option-input]', section);
    if (!inputs.length) return;
    var variantIdField = qs('[data-variant-id]', section);
    var priceEl = qs('[data-price]', section), compareEl = qs('[data-compare]', section), offEl = qs('[data-off]', section);
    var addBtn = qs('[data-add-to-cart]', section), addLabel = qs('[data-add-label]', section);
    var buyNowBtn = qs('[data-buy-now]', section);
    var stickyAdd = qs('[data-sticky-add]', section), stickyPrice = qs('[data-sticky-price]', section);
    var skuEl = qs('[data-sku]', section);

    function getSelected() {
      var selected = [];
      qsa('fieldset[data-option-index]', section).forEach(function (fs) {
        var checked = qs('input:checked', fs);
        selected.push(checked ? checked.value : null);
      });
      return selected;
    }
    function findVariant(selected) {
      return product.variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      })[0];
    }
    function updateAvailability(selected) {
      qsa('fieldset[data-option-index]', section).forEach(function (fs, idx) {
        qsa('input[data-option-input]', fs).forEach(function (input) {
          var testSelected = selected.slice();
          testSelected[idx] = input.value;
          var match = product.variants.some(function (v) {
            return v.available && v.options.every(function (opt, i) {
              return testSelected[i] == null || opt === testSelected[i];
            });
          });
          input.classList.toggle('is-unavailable', !match);
        });
      });
    }
    function render(variant) {
      if (!variant) return;
      if (variantIdField) variantIdField.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) { compareEl.hidden = !onSale; if (onSale) compareEl.textContent = formatMoney(variant.compare_at_price); }
      if (offEl) {
        if (onSale) {
          var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          offEl.hidden = false;
          offEl.textContent = pct + '% OFF';
        } else { offEl.hidden = true; }
      }
      if (skuEl && variant.sku) skuEl.textContent = variant.sku;
      var available = variant.available;
      [addBtn, buyNowBtn, stickyAdd].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !available;
      });
      if (addLabel) addLabel.textContent = available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
      qsa('[data-option-selected]', section).forEach(function (el, i) {
        el.textContent = variant.options[i];
      });
      var stockChip = qs('[data-stock-chip]', section);
      if (stockChip) {
        stockChip.textContent = available ? (strings.inStock || 'In Stock') : (strings.soldOut || 'Sold out');
        stockChip.classList.toggle('is-out', !available);
      }
      // Update URL + browser history without reload
      if (variant.id && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var selected = getSelected();
        updateAvailability(selected);
        var variant = findVariant(selected);
        render(variant);
      });
    });
    updateAvailability(getSelected());
  }

  function initQtyStepper(section, maxQty) {
    // Scoped to the product form only — cart-line quantity steppers (which carry
    // a data-line attribute) are handled separately by the delegated cart handlers.
    qsa('[data-qty]', section).forEach(function (wrap) {
      var input = qs('[data-qty-input]', wrap);
      var minus = qs('[data-qty-minus]', wrap), plus = qs('[data-qty-plus]', wrap);
      if (!input || !minus || !plus || minus.hasAttribute('data-line')) return;
      function clamp(v) { return Math.max(1, Math.min(maxQty, v)); }
      minus.addEventListener('click', function () { input.value = clamp((parseInt(input.value, 10) || 1) - 1); });
      plus.addEventListener('click', function () {
        var next = (parseInt(input.value, 10) || 1) + 1;
        if (next > maxQty) { toast((strings.maxQty || 'Max {{ max }} per order').replace('{{ max }}', maxQty)); next = maxQty; }
        input.value = clamp(next);
      });
      input.addEventListener('change', function () { input.value = clamp(parseInt(input.value, 10) || 1); });
    });
  }

  function initPincode(section) {
    var form = qs('[data-pincode-form]', section);
    if (!form) return;
    var input = qs('[data-pincode-input]', section);
    var result = qs('[data-delivery-result]', section);
    var hint = qs('[data-pincode-hint]', section);

    form.addEventListener('submit', function (e) { e.preventDefault(); check(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(); } });

    function check() {
      var val = input.value.trim();
      if (!/^[0-9]{6}$/.test(val)) {
        hint.textContent = 'Please enter a valid 6-digit pincode';
        hint.style.color = 'var(--primary)';
        result.classList.add('is-error');
        return;
      }
      hint.style.color = '';
      result.classList.remove('is-error');
      var okTitle = qs('.delivery__ok-title', result);
      var okSub = qs('.delivery__ok-sub', result);
      if (okTitle) okTitle.innerHTML = '\u2713 Delivery available to ' + val;
      hint.textContent = 'Enter a different pincode to re-check';
    }
  }

  function initStickyAtc(section) {
    var bar = qs('[data-sticky-atc]', section);
    var addBtn = qs('[data-add-to-cart]', section);
    var stickyAdd = qs('[data-sticky-add]', section);
    var stage = qs('.pinfo', section);
    if (!bar || !stage) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-show', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0, rootMargin: '-90px 0px 0px 0px' });
    var buyRow = qs('.buyrow', stage);
    if (buyRow) io.observe(buyRow);

    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        if (addBtn) addBtn.click();
      });
    }
  }

  function initFormSubmit(section) {
    var form = qs('.pform', section);
    if (!form) return;
    var addBtn = qs('[data-add-to-cart]', form);
    var addLabel = qs('[data-add-label]', form);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!addBtn || addBtn.disabled || addBtn.classList.contains('is-loading')) return;
      var variantId = qs('[data-variant-id]', form).value;
      var qtyInput = qs('[data-qty-input]', form);
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var originalText = addLabel ? addLabel.textContent : '';
      addBtn.classList.add('is-loading');
      if (addLabel) addLabel.textContent = strings.adding || 'Adding…';
      Cart.add(variantId, qty, function (err) {
        addBtn.classList.remove('is-loading');
        if (err) {
          if (addLabel) addLabel.textContent = originalText;
          toast((err && err.description) || strings.error || 'Something went wrong', true);
          return;
        }
        if (addLabel) addLabel.textContent = strings.addedToCart || 'Added to cart';
        toast(strings.addedToCart || 'Added to cart');
        setTimeout(function () { if (addLabel) addLabel.textContent = originalText; }, 1600);
        openDrawerIfEnabled();
      });
    });
  }

  function initBuyNow(section) {
    var btn = qs('[data-buy-now]', section);
    var form = qs('.pform', section);
    if (!btn || !form) return;
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var variantId = qs('[data-variant-id]', form).value;
      var qtyInput = qs('[data-qty-input]', form);
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      window.location.href = routes.root + 'cart/' + variantId + ':' + qty;
    });
  }

  /* ------------------------------------------------------------------ */
  /* Related products — fetch real Shopify recommendations client-side   */
  /* ------------------------------------------------------------------ */
  function initRelatedProducts() {
    var section = qs('[data-related-section]');
    if (!section) return;
    var productId = section.getAttribute('data-product-id');
    if (!productId) return; // static fallback (e.g. collection page) — leave server-rendered markup
    var sectionId = section.getAttribute('data-section-id') || getSectionId(section);
    if (!sectionId) return;
    var url = routes.root + 'recommendations/products?product_id=' + productId +
      '&limit=' + (qs('[data-related-grid]', section) ? 6 : 6) +
      '&intent=related&section_id=' + sectionId;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-related-grid]');
        var grid = qs('[data-related-grid]', section);
        if (newGrid && grid && newGrid.children.length) {
          grid.innerHTML = newGrid.innerHTML;
          initWishlist(); // re-bind wishlist state on freshly injected cards
        }
      })
      .catch(function () { /* keep server-rendered fallback */ });
  }
  function getSectionId(section) {
    var el = section.closest('[id^="shopify-section-"]');
    return el ? el.id.replace('shopify-section-', '') : null;
  }

  /* ------------------------------------------------------------------ */
  /* Recently viewed products                                           */
  /* ------------------------------------------------------------------ */
  function trackRecentlyViewed() {
    var section = qs('[data-product-section]');
    if (!section) return;
    var handle = section.getAttribute('data-product-handle');
    if (!handle) return;
    try {
      var KEY = 'otk-recently-viewed';
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      list = list.filter(function (h) { return h !== handle; });
      list.unshift(handle);
      list = list.slice(0, 12);
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function renderRecentlyViewed() {
    var section = qs('[data-recently-viewed]');
    if (!section) return;
    var grid = qs('[data-rv-grid]', section);
    var currentHandle = qs('[data-product-section]') ? qs('[data-product-section]').getAttribute('data-product-handle') : null;
    var list;
    try { list = JSON.parse(localStorage.getItem('otk-recently-viewed') || '[]'); } catch (e) { list = []; }
    list = list.filter(function (h) { return h !== currentHandle; }).slice(0, 6);
    if (!list.length) { section.hidden = true; return; }

    Promise.all(list.map(function (handle) {
      return fetch(routes.root + 'products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) { section.hidden = true; return; }
      grid.innerHTML = products.map(renderMiniCard).join('');
      section.hidden = false;
      initWishlist();
    });
  }

  function renderMiniCard(p) {
    var img = p.featured_image ? p.featured_image.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '$1$2') : '';
    var onSale = p.compare_at_price_max > p.price_min;
    return '<article class="pcard" data-handle="' + p.handle + '">' +
      '<div class="pcard__media">' +
      '<a class="pcard__link" href="' + p.url + '">' +
      (img ? '<img class="pcard__img" src="' + img + '&width=500" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
      '</a>' +
      '<button type="button" class="pcard__wish" data-wishlist-toggle data-handle="' + p.handle + '" aria-label="Wishlist" aria-pressed="false">\u2661</button>' +
      '</div>' +
      '<div class="pcard__info">' +
      '<p class="pcard__cat">' + escapeHtml(p.type || p.vendor || '') + '</p>' +
      '<h3 class="pcard__title"><a href="' + p.url + '">' + escapeHtml(p.title) + '</a></h3>' +
      '<div class="pcard__price"><span class="pcard__now">' + formatMoney(p.price) + '</span>' +
      (onSale ? '<s class="pcard__was">' + formatMoney(p.compare_at_price_max) + '</s>' : '') +
      '</div></div></article>';
  }

  /* ------------------------------------------------------------------ */
  /* Count-up stats (Our story)                                         */
  /* ------------------------------------------------------------------ */
  function initCountUp() {
    var nums = qsa('[data-count-to]');
    if (!nums.length) return;
    var seen = new WeakSet();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || seen.has(entry.target)) return;
        seen.add(entry.target);
        animate(entry.target);
      });
    }, { threshold: 0.4 });
    nums.forEach(function (el) { io.observe(el); });

    function animate(el) {
      var target = parseFloat(el.getAttribute('data-count-to')) || 0;
      var suffix = el.getAttribute('data-suffix') || '';
      var useFormat = el.getAttribute('data-format') === 'true';
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var current = Math.round(target * eased);
        el.textContent = (useFormat ? current.toLocaleString('en-IN') : current) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
  }

  /* ------------------------------------------------------------------ */
  /* Collection filter drawer (mobile)                                   */
  /* ------------------------------------------------------------------ */
  function initFilterDrawer() {
    var filters = qs('.filters');
    var openBtn = qs('[data-filter-open]');
    var closeBtns = qsa('[data-filter-close]');
    var overlay = qs('[data-filter-overlay]');
    if (!filters || !openBtn) return;
    function open() { filters.classList.add('is-open'); lockScroll(true); if (overlay) overlay.hidden = false; }
    function close() { filters.classList.remove('is-open'); lockScroll(false); if (overlay) overlay.hidden = true; }
    openBtn.addEventListener('click', open);
    closeBtns.forEach(function (b) { b.addEventListener('click', close); });
    if (overlay) overlay.addEventListener('click', close);
  }

  function initSortSelect() {
    var select = qs('[data-sort-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Init                                                               */
  /* ------------------------------------------------------------------ */
  function init() {
    initThemeToggle();
    initAnnouncement();
    initMobileMenu();
    initSearch();
    initCartDrawer();
    initQuickAdd();
    initWishlist();
    initShare();
    initHero();
    initFranchiseScroll();
    initAccordions();
    initProductPage();
    initRelatedProducts();
    trackRecentlyViewed();
    renderRecentlyViewed();
    initCountUp();
    initFilterDrawer();
    initSortSelect();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.otk = otk;
})();
